import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { Control, Controller } from "react-hook-form";
import { CreateCalendarEventForm } from "app/services/api/types/calendar/requests/CreateCalendarEventForm";
import {
  Checkbox,
  CheckboxIndicator,
  CheckboxIcon,
  CheckboxLabel,
} from "ui/gluestack/checkbox";

import { CheckIcon } from "ui/gluestack/icon";
import { FormControlledInputTextArea } from "ui/molecules/form/FormControlledInputTextArea";

interface Props {
  control: Control<CreateCalendarEventForm>;
}

export function NotesSection({ control }: Props) {
  return (
    <View>
      <Text className="text-gray-500 mb-4 text-sm">Note</Text>
      <Controller
        control={control}
        name="preparation_needed"
        render={({ field: { value, onChange } }) => (
          <Checkbox
            isChecked={!!value}
            onChange={(checked: boolean) => onChange(checked)}
            aria-label="Preparation needed"
            size="sm"
            className="gap-4 mb-4"
            value={value ? "checked" : "unchecked"}
          >
            <CheckboxIndicator>
              <CheckboxIcon as={CheckIcon} />
            </CheckboxIndicator>
            <CheckboxLabel>
              Mark if any preparation is needed and specify what (for example if
              bloods need to be taken prior to an appointment).
            </CheckboxLabel>
          </Checkbox>
        )}
      />
      <FormControlledInputTextArea
        id="notes"
        name="notes"
        control={control}
        placeholder="Enter any additional information here"
        className="text-gray-500"
        rules={{
          validate: {
            requiredIf: (value, formValues) => {
              if (formValues.preparation_needed && !value) {
                return "Note is required";
              }
            },
          },
        }}
      />
    </View>
  );
}
